import React from 'react';
import { useInView } from 'react-intersection-observer';

import { JDPModuleName } from '@/components/job-posting/types';

import { ScrollTrackingEvent, useJobPostingScrollTracking } from '../../contexts';

type ScrollOptions = { bottom?: string; threshold?: number };

type ScrollTrackingModuleProps = {
  customTrackingProps?: ScrollTrackingEvent['customTrackingProps'];
  moduleTrackingName: JDPModuleName;
  scrollOptions?: ScrollOptions;
  trackInView?: boolean;
};

export const ScrollTrackingModuleWrapper: React.FC<ScrollTrackingModuleProps> = ({
  children,
  customTrackingProps,
  moduleTrackingName,
  scrollOptions = {},
  trackInView = false,
}) => {
  const { bottom = '0px', threshold = 1 } = scrollOptions;
  const rootMargin = `0px 0px ${bottom} 0px`;

  const trackScrollEvent = useJobPostingScrollTracking();
  const handleOnScrollInto = (inView: boolean): void => {
    if (inView) {
      trackScrollEvent({ moduleName: moduleTrackingName, customTrackingProps });
    }
  };

  const { ref } = useInView({
    threshold,
    triggerOnce: true,
    rootMargin,
    onChange: handleOnScrollInto,
  });

  if (!children) {
    return null;
  }

  return trackInView ? (
    <div ref={ref} data-testid="scroll-tracking-module-wrapper">
      {children}
    </div>
  ) : (
    <>
      {children}
      <div ref={ref} data-testid="scroll-tracking-module-wrapper" />
    </>
  );
};
